import { createReducer } from 'redux-starter-kit';
import { handleError } from '../../utils/handleError';
import i18next from 'i18next';
import { ReportsPageApi } from './ReportsPageApi';
/**
 * Constants
 */

export const reportsPageModule = 'reportsPage';
const LOADING = `${reportsPageModule}/LOADING`;
const LIST_EMAIL_DATA = `${reportsPageModule}/LIST_EMAIL_DATA`;
const CLEAR_STATE = `${reportsPageModule}/CLEAR_STATE`;
const LOADING_DELETE_EMAIL = `${reportsPageModule}/LOADING_DELETE_EMAIL`;
const LOADING_ADD_EMAIL = `${reportsPageModule}/LOADING_ADD_EMAIL`;



/**
 * Reducer
 */

const initialState = {
  loading: false,
  loadingDeleteEmail: false,
  loadingAddEmail: false,
  emailList: {
    content: [],
    totalElements: 0,
  },
};

export default createReducer(initialState, {
  [LOADING]: (state, action) => {
    state.loading = action.payload;
  },
  [LIST_EMAIL_DATA]: (state, action) => {
    const filter = action.filter || {};
    if (filter.pageNumber && filter.pageNumber !== 1) {
      state.emailList.content = [
        ...state.emailList.content,
        ...action.payload.content,
      ];
    } else {
      state.emailList = action.payload;
    }
  },
  [LOADING_DELETE_EMAIL]: (state, action) => {
    state.loadingDeleteEmail = action.payload;
  },
  [LOADING_ADD_EMAIL]: (state, action) => {
    state.loadingAddEmail = action.payload;
  },
  [CLEAR_STATE]: () => initialState
});

/**
 * Actions
 */

export const clearState = () => ({ type: CLEAR_STATE });

export const loadEmailList = ({ filter }) => async dispatch => {
  try {
    dispatch({ type: LOADING, payload: true });
    const { data } = await ReportsPageApi.loadEmailList(JSON.stringify(filter));
    dispatch({
      type: LIST_EMAIL_DATA,
      payload: data.result,
      filter,
    });
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorLoadEmailList'));
  } finally {
    dispatch({ type: LOADING, payload: false });
  }
};

export const deleteEmail = (data, reloadPage, closeModal) => async dispatch => {
  dispatch({ type: LOADING_DELETE_EMAIL, payload: true });
  try {
    const response = await ReportsPageApi.deleteEmail(data);
    if (response.data.status === 'SUCCESS') {
      reloadPage();
      closeModal();
    } else {
      handleError(response, i18next.t('reportsPage_errorDeleteEmail'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorDeleteEmail'));
  } finally {
    dispatch({ type: LOADING_DELETE_EMAIL, payload: false });
  }
};
export const addEmail = (email, reloadPage, closeModal) => async dispatch => {
  dispatch({ type: LOADING_ADD_EMAIL, payload: true });
  try {
    const response = await ReportsPageApi.addEmail(email);
    if (response.data.status === 'SUCCESS') {
      reloadPage();
      closeModal();
    } else {
      handleError(response, i18next.t('reportsPage_errorAddEmail'));
    }
  } catch (error) {
    handleError(error, i18next.t('reportsPage_errorAddEmail'));
  } finally {
    dispatch({ type: LOADING_ADD_EMAIL, payload: false });
  }
};


